<template>
  <div id="Index">
    <jw-navigation>
      <banner></banner>
      <Row :gutter="10" class="card-row">
        <Col span="24">
          <Card :bordered="true" :shadow="true" style="height: 280px;margin: 10px 5px 0 5px;">
            <template slot="extra">
              <span class="more-button" @click="onClickMore('association')">更多</span>
            </template>
            <p slot="title">中国双截棍协会简介</p>
            <template slot="extra">
<!--              <span class="more-button">更多</span>-->
            </template>
            <p style="line-height: 28px;">
              {{introduction}}
            </p>
          </Card>
        </Col>
<!--        <Col span="12">-->
<!--          <Card :bordered="false" :shadow="true" style="height: 280px;margin: 10px 5px 0 5px;">-->
<!--            <p slot="title">证书查询</p>-->
<!--            <template slot="extra">-->
<!--              <span class="more-button" @click="handleQueryCertificateAction">查询</span>-->
<!--            </template>-->
<!--            <query ref="query" :show-query-button="false"></query>-->
<!--          </Card>-->
<!--        </Col>-->
      </Row>

      <Row :gutter="10" class="card-row">
        <Col span="24">
          <Card :bordered="true" :shadow="true" style="height: 560px;margin: 10px 5px 0 5px;">
            <p slot="title">组织成员</p>
            <template slot="extra">
              <span class="more-button" @click="onClickMore('association')">更多</span>
            </template>
            <member></member>
          </Card>
        </Col>
      </Row>

      <Row :gutter="10" class="card-row">
        <Col span="24">
          <Card :bordered="true" :shadow="true" style="height: 280px;margin: 10px 5px 0 5px;">
            <p slot="title">新闻中心</p>
            <template slot="extra">
              <span class="more-button" @click="onClickMore('news')">更多</span>
            </template>
            <news></news>
          </Card>
        </Col>
      </Row>

      <Row :gutter="10" class="card-row">
        <Col span="24">
          <Card :bordered="true" :shadow="true" style="height: 480px;margin: 10px 5px 0 5px;">
            <p slot="title">会员单位</p>
            <template slot="extra">
              <span class="more-button" @click="onClickMore('member')">更多</span>
            </template>
            <member-unit></member-unit>
          </Card>
        </Col>

        <Col span="12" v-show="false">
          <Card :bordered="true" :shadow="true" style="height: 240px;margin: 10px 5px 0 5px;">
            <p slot="title">精彩视频</p>
            <template slot="extra">
              <span class="more-button">更多</span>
            </template>
            <p>Content of card</p>
            <p>Content of card</p>
            <p>Content of card</p>
          </Card>
        </Col>
      </Row>

      <Row :gutter="10" class="card-row" v-show="false">
        <Col span="24">
          <Card :bordered="true" :shadow="true" style="height: 240px;margin: 10px 5px 0 5px;">
            <p slot="title">精彩图片</p>
            <template slot="extra">
              <span class="more-button">更多</span>
            </template>
            <p>Content of card</p>
            <p>Content of card</p>
            <p>Content of card</p>
          </Card>
        </Col>
      </Row>
    </jw-navigation>
  </div>
</template>

<script>
import Banner from "@/views/web/home/components/Banner";
import News from "@/views/web/home/components/News";
import Query from "@/components/Query";
import Member from "@/views/web/home/components/Member";
import MemberUnit from "@/views/web/home/components/MemberUnit.vue";
import {getIntroduction} from "@/request/web/introduction";

export default {
  name: "Index",
  components: {
    Banner,
    News,
    Query,
    Member,
    MemberUnit
  },
  data() {
    return {
      introduction: ''
    }
  },
  created() {
    this.onGetIntroduction()
  },
  methods: {
    onClickMore(page) {
      let path = `/${page}`;
      this.$router.push(path)
    },
    handleQueryCertificateAction() {
      this.$refs['query'].clickQueryButtonAction()
    },
    onGetIntroduction() {
      getIntroduction().then(res=> {
        this.introduction = res.data.data.introduction['content']
      })
    }
  }
}
</script>

<style scoped>
.card-row {

}

.more-button {
  cursor: pointer;
}

</style>
